(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('haave-card-gallery')) {
  customElements.define('haave-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const track = this.querySelector('.haave-card-gallery__track');
      const slides = Array.from(track.children);
      const count = this.querySelector('.haave-card-gallery__controls span');
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const next = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth) + Number(button.dataset.step)));
        track.scrollTo({left:next * track.clientWidth, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', () => {
        const current = Math.round(track.scrollLeft / track.clientWidth);
        if (count) count.textContent = (current + 1) + ' / ' + slides.length;
      }, {passive:true});
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
